
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/cash-advance",
      function () {
        return require("private-next-pages/compare/cash-advance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/cash-advance"])
      });
    }
  